
import { defineComponent } from 'vue'
import useClipboard from 'vue-clipboard3'
import { ElMessage } from 'element-plus'
import { getAllSsr, getUpdateSsr } from '@/api/ssr'
import { getAllV2ray } from '@/api/v2ray'
import { newDiscuss, allDiscuss } from '@/api/discuss'

export default defineComponent({
  setup() {
    const { toClipboard } = useClipboard()

    const copy = async (text: string) => {
      try {
        await toClipboard(text)
      } catch (e) {
        console.error(e)
      }
    }

    return { copy }
  },
  data() {
    return {
      activeNames: ['1'],
      // 所有ssr节点
      ssrList: [],
      // 所有v2ray节点
      v2rayList: [],
      // 判断用户是否留言成功，1为隐藏，2为成功，3为失败
      commentFlag: 1,
      // 用户留言信息
      commentData: {
        nickname: '', // 用户昵称
        content: '' // 用户留言内容
      },
      // 用户留言列表
      discussList: {},
      // ssr/v2ray节点更新记录
      ssrUpdateInfo: {}
    }
  },
  created() {
    // 获取所有ssr节点
    this.fetchSsrList()
    // 获取所有v2ray节点
    this.fetchV2rayList()
    // 获取所有留言
    this.fetchAllDiscuss(1)
    // 获取所有节点更新信息
    this.fetchSsrUpdates(1)
  },
  methods: {
    // 获取所有ssr节点
    async fetchSsrList() {
      const res = await getAllSsr()
      this.ssrList = res
    },
    // 复制SSR链接
    copySsr(name: string, url: string) {
      url = url?.slice(0, 15) + '' + url?.slice(16)
      this.copy(url)
      ElMessage.success('恭喜您，复制 ' + name + ' SSR节点成功！')
    },
    // 复制所有SSR节点
    copyAllSsr() {
      let text = ''
      this.ssrList.forEach((item: any) => {
        item.url = item?.url?.slice(0, 15) + '' + item?.url?.slice(16)
        text += item.url + '\n'
      })
      this.copy(text)
      ElMessage.success('恭喜您，复制所有SSR节点成功！')
    },
    // 获取所有v2ray节点
    async fetchV2rayList() {
      const res = await getAllV2ray()
      this.v2rayList = res
    },
    // 复制V2ray链接
    copyV2ray(name: string, url: string) {
      url = url?.slice(0, 15) + '' + url?.slice(16)
      this.copy(url)
      ElMessage.success('恭喜您，复制 ' + name + ' V2ray节点成功！')
    },
    // 复制所有V2ray节点
    copyAllV2ray() {
      let text = ''
      this.v2rayList.forEach((item: any) => {
        item.url = item?.url?.slice(0, 15) + '' + item?.url?.slice(16)
        text += item.url + '\n'
      })
      this.copy(text)
      ElMessage.success('恭喜您，复制所有V2ray节点成功！')
    },
    // 关闭留言提示框，然后让是否显示留言提示框恢复初始值，并隐藏
    closeInput() {
      this.commentFlag = 1
    },
    // 重置留言
    resetComment() {
      this.commentData.nickname = ''
      this.commentData.content = ''
    },
    // 发表留言
    async doComment() {
      if (this.commentData.nickname.length === 0) {
        this.commentFlag = 3
        ElMessage.error('请输入用户昵称')
      } else if (this.commentData.content.length === 0) {
        this.commentFlag = 3
        ElMessage.error('请输入留言内容')
      } else {
        const res = await newDiscuss(this.commentData)
        this.commentData.nickname = ''
        this.commentData.content = ''
        // 判断留言是否成功
        if (res.code === 1) {
          this.commentFlag = 2
        } else {
          this.commentFlag = 3
        }
      }
    },
    // 获取所有留言
    async fetchAllDiscuss(pageNum: number) {
      const res = await allDiscuss(pageNum)
      this.discussList = res
    },
    // 留言板分页
    async changePage(pageNum: number) {
      this.fetchAllDiscuss(pageNum)
    },
    // 获取所有SSR更新信息
    async fetchSsrUpdates(pageNum: number) {
      const res = await getUpdateSsr(pageNum)
      this.ssrUpdateInfo = res
    },
    // ssr更新记录分页
    async UpdateSsrPage(pageNum: number) {
      this.fetchSsrUpdates(pageNum)
    }
  }
})
